import type { RootState } from '@app/store';

export const selectCallMinimalMode = (state: RootState) => state.appSettings.callMinimalMode;
